import de from './translations/de'
export default de
